import { useReducer, useState, useContext } from "react"
import { Context } from "../store/UserProvider"

const inputReducer = (state, action) => {
  if (action.type === "OLD_PASS") {
    return {
      oldPassword: {
        val: action.val,
        valid: action.val.length < 6 ? false : true,
      },

      password: {
        val: state.password.val,
        valid: state.password.valid,
      },

      comparePassword: {
        val: state.comparePassword.val,
        valid: state.comparePassword.valid,
      },
    }
  }

  if (action.type === "NEW_PASS") {
    return {
      oldPassword: {
        val: state.oldPassword.val,
        valid: state.oldPassword.valid,
      },

      password: {
        val: action.val,
        valid: action.val.length < 6 ? false : true,
      },

      comparePassword: {
        val: state.comparePassword.val,
        valid: state.comparePassword.valid,
      },
    }
  }

  if (action.type === "PASS_CHECK") {
    return {
      oldPassword: {
        val: state.oldPassword.val,
        valid: state.oldPassword.valid,
      },

      password: {
        val: state.password.val,
        valid: state.password.valid,
      },

      comparePassword: {
        val: action.val,
        valid:
          action.val !== state.password.val || action.val.length < 6
            ? false
            : true,
      },
    }
  }

  return {
    oldPassword: {
      val: "",
      valid: true,
    },

    password: {
      val: "",
      valid: true,
    },

    comparePassword: {
      val: "",
      valid: true,
    },
  }
}

const useChangePass = () => {
  const ctx = useContext(Context)
  const [inputState, dispatchInput] = useReducer(inputReducer, {
    oldPassword: {
      val: "",
      valid: true,
    },

    password: {
      val: "",
      valid: true,
    },

    comparePassword: {
      val: "",
      valid: true,
    },
  })

  const [submit, setSubmit] = useState(false)
  const [nextStep, setNextStep] = useState(false)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const inputHandler = event => {
    if (event.target.dataset.id === "oldPassword") {
      dispatchInput({ type: "OLD_PASS", val: event.target.value })
    } else if (event.target.dataset.id === "newPassword") {
      dispatchInput({ type: "NEW_PASS", val: event.target.value })
      dispatchInput({
        type: "PASS_CHECK",
        val: inputState.comparePassword.val,
      })
    } else if (event.target.dataset.id === "confirmPassword") {
      dispatchInput({ type: "PASS_CHECK", val: event.target.value })
    }
  }

  const changeUserPassword = async (token, userId) => {
    setLoading(true)
    const myHeaders = new Headers()
    myHeaders.append("Authorization", `Bearer ${token}`)

    const formdata = new FormData()
    formdata.append("userId", `${userId}`)
    formdata.append("currentPassword", `${inputState.oldPassword.val}`)
    formdata.append("newPassword", `${inputState.password.val}`)

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    }

    fetch(`https://montessori-back.herokuapp.com/api/password`, requestOptions)
      .then(response => response.text())
      .then(result => {
        if (result !== "password changed succesfully") {
          const resultData = JSON.parse(result)
          console.log(resultData)
          setError(resultData.error.message)
          setLoading(false)
        } else {
          setNextStep(true)
          resetData()
        }
      })
      .catch(error => {
        console.log(error.message)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const formHandler = event => {
    event.preventDefault()
    setSubmit(true)

    if (
      inputState.oldPassword.valid &&
      inputState.oldPassword.val &&
      inputState.password.valid &&
      inputState.password.val &&
      inputState.comparePassword.valid &&
      inputState.comparePassword.val
    ) {
      changeUserPassword(ctx.userGlobalState.token, ctx.userGlobalState.userId)
    } else {
      dispatchInput({ type: "OLD_PASS", val: inputState.oldPassword.val })
      dispatchInput({ type: "NEW_PASS", val: inputState.password.val })
      dispatchInput({
        type: "PASS_CHECK",
        val: inputState.comparePassword.val,
      })
    }
  }

  const resolveInputServerError = event => {
    if (event.target.dataset.id === "oldPassword" && error) {
      setSubmit(false)
      setError(null)
    }
  }

  const resetData = () => {
    dispatchInput({ type: "RESET_INPUT" })
    setSubmit(false)
    setError(null)
  }

  return {
    inputHandler: inputHandler,
    formHandler: formHandler,
    resolveInputServerError: resolveInputServerError,
    setNextStep: setNextStep,
    inputState: inputState,
    submit: submit,
    error: error,
    nextStep: nextStep,
    loading: loading,
  }
}

export default useChangePass
